import ActionLink from '../../../Components/Dashboard/ActionLink';
import DashboardRoot from '../../../Components/Dashboard/DashboardRoot';
import PageHead from '../../../Components/Dashboard/PageHead';
import DashboardGrid, { Row } from '../../../Components/Dashboard/DashboardGrid';
import { formatShortDate } from '../../../Utils/dates/formatDate';
import RecentSignInsCard from './signIns/RecentSignInsCard';
import AccountActivityCard from './accountActivity/AccountActivityCard';
import BackupStatusCard from './backup/BackupStatusCard';
import RecentlyJoinedCard from './recentlyJoined/RecentlyJoinedCard';
import FeedbackSummaryCard from './feedback/FeedbackSummaryCard';
import ActiveUsersCard from './activeUsers/ActiveUsersCard';
import AnalyticsCards from './analytics/AnalyticsCards';
import adminStyles from './adminCards.module.css';

// Every card calls an admin-only API; the server enforces the role, not this page.
export default function DashboardPage({ now: nowProp }) {
    const now = nowProp || new Date();
    return (
        <DashboardRoot>
            <PageHead
                crumb={`Administrator · ${formatShortDate(now)} ${now.getFullYear()}`}
                title="User access"
                actions={
                    <>
                        <ActionLink to="/users">User Management</ActionLink>
                        <ActionLink to="/feedback-inspection">Feedback</ActionLink>
                        <ActionLink to="/admin_security">Account security</ActionLink>
                    </>
                }
            />
            <DashboardGrid
                fold={<RecentSignInsCard now={nowProp} />}
                stack={[<AccountActivityCard key="aa" />, <BackupStatusCard key="bk" />]}
            />
            <Row className={adminStyles.accessRow}>
                <RecentlyJoinedCard />
                <FeedbackSummaryCard now={nowProp} />
                <ActiveUsersCard />
            </Row>
            <div className={adminStyles.auFull}>
                <AnalyticsCards />
            </div>
        </DashboardRoot>
    );
}
